<template>
  <div ref="header" id="header" :class="{ '-blur': isHeaderBlur }">
    <header id="header-content" ref="headerRef" class="header-content">
      <div
        v-if="!isPartSP"
        ref="headerLogo"
        id="header-logo"
        class="header-logo"
        :class="{ '-active': isLogoActive }"
        @click="clickTransitionHeaderButton(transitionType.Top)"
      >
        <img
          class="icon logo"
          src="~/assets/pages/common/LogoAmahitotsu_Color_H.svg"
          :alt="$t('util.title')"
        />
      </div>

      <div v-if="!isPartSP" class="header-button-content">
        <!-- PC　ヘッダーボタン一覧 -->
        <button
          class="about-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.About)"
        >
          <span class="text">{{ $t('header.about') }}</span
          ><span class="text text_jp">{{ $t('header.about_trans') }}</span>
        </button>
        <button
          class="stay-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Stay)"
        >
          <span class="text">{{ $t('header.stay') }}</span
          ><span class="text text_jp" v-html="$t('header.stay_trans')"></span>
        </button>
        <button
          class="food-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Food)"
        >
          <span class="text">{{ $t('header.food') }}</span
          ><span class="text text_jp">{{ $t('header.food_trans') }}</span>
        </button>
        <button
          class="cafe-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Cafe)"
        >
          <span class="text">{{ $t('header.cafe') }}</span
          ><span class="text text_jp" v-html="$t('header.cafe_trans')"></span>
        </button>
        <button
          class="access-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Access)"
        >
          <span class="text">{{ $t('header.access') }}</span
          ><span class="text text_jp">{{ $t('header.access_trans') }}</span>
        </button>
        <button
          class="faq-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Faq)"
        >
          <span class="text">{{ $t('header.faq') }}</span
          ><span class="text text_jp">{{ $t('header.faq_trans') }}</span>
        </button>
        <button
          class="contact-button header-button header-button-middle"
          :class="localeClass"
          @click="clickTransitionHeaderButton(transitionType.Contact)"
        >
          <span class="text">{{ $t('header.contact') }}</span
          ><span class="text text_jp">{{ $t('header.contact_trans') }}</span>
        </button>
        <button
          class="reservation-button header-button header-button-content-large"
          @click="clickReservedForm"
        >
          <span class="text">
            {{ $t('header.reservation_plan') }}
          </span>
        </button>
      </div>

      <div v-else class="header-button-sp-content">
        <!-- SP　ヘッダーボタン一覧 -->
        <button class="header-button-sp" @click="clickTransitionHeaderButton(transitionType.Access)">
          <span class="access-icon svg" />
          <span class="text" :class="localeClass">{{ $t('header.sp.access') }}</span>
        </button>
        <button class="header-button-sp" @click="clickTransitionHeaderButton(transitionType.Contact)">
          <span class="contact-icon svg" />
          <span class="text" :class="localeClass">{{ $t('header.sp.contact') }}</span>
        </button>
        <button
          class="reservation-button header-button header-button-content-large"
          @click="clickReservedForm"
        >
          <span class="text">
            {{ $t('header.reservation_plan') }}
          </span>
        </button>
        <div class="ui-hamburger">
          <button
            class="hamburger-button"
            @click="toggle"
            :aria-expanded="isHamburgerMenuOpen"
            :aria-label="$t('header.hamburger_menu.menu')"
          >
            <span class="bar" :class="{ open: isHamburgerMenuOpen }" />
          </button>
        </div>
      </div>
    </header>
    <div ref="headerAfter" id="header-after" class="header-after" />
  </div>
  <div v-if="isPartSP">
    <transition name="fade">
      <div v-if="isHamburgerMenuOpen" class="hamburger-overlay" @click.self="close">
        <!-- ハンバーガーメニュー -->
        <nav class="hamburger-menu" role="dialog" aria-modal="true">
          <div
            ref="headerLogo"
            id="header-logo"
            class="header-logo"
            @click="clickTransitionHeaderButton(transitionType.Top)"
          >
            <img
              class="icon logo"
              src="~/assets/pages/common/LogoAmahitotsu_Color_H.svg"
              :alt="$t('util.title')"
            />
          </div>
          <ul class="menu-list line">
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.About)">
              <div class="menu-title">{{ $t('header.hamburger_menu.about') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.about_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Stay)">
              <div class="menu-title">{{ $t('header.hamburger_menu.stay') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.stay_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Food)">
              <div class="menu-title">{{ $t('header.hamburger_menu.food') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.food_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Cafe)">
              <div class="menu-title">{{ $t('header.hamburger_menu.cafe') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.cafe_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Access)">
              <div class="menu-title">{{ $t('header.hamburger_menu.access') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.access_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Faq)">
              <div class="menu-title">{{ $t('header.hamburger_menu.faq') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.faq_trans') }}</div>
            </button></li>
            <li><button class="menu-item" @click="clickTransitionHeaderButton(transitionType.Contact)">
              <div class="menu-title">{{ $t('header.hamburger_menu.contact') }}</div>
              <div class="menu-description">{{ $t('header.hamburger_menu.contact_trans') }}</div>
            </button></li>
          </ul>
        </nav>
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
import {
  actionExternalNewTabTransition,
  actionTransition,
  type actionTransitionType, externalTransitionType,
  transitionType,
} from '@/models/Utility'
import { useMounted, useWindowSize } from "@vueuse/core";
const { width } = useWindowSize()
const { isLangSelectActive } = useUtil()

onMounted(() => {
  initCheckHeader()
})

const { locale } = useI18n()
const localeClass = computed(() => `-${locale.value}`)

// ヘッダーのブラー有効化・無効化切り替え
const isHeaderBlur = ref<boolean>(false)
// ヘッダーのロゴ表示・非表示切り替え
const isLogoActive = ref<boolean>(false)
// UIが最上部に来たか判定用の要素
const headerAfter = ref<HTMLElement|null>(null)
// SP：メニューが開いているかどうか
const isHamburgerMenuOpen = ref(false)
const toggle = () => { isHamburgerMenuOpen.value = !isHamburgerMenuOpen.value }
const close = () => { isHamburgerMenuOpen.value = false }

// ハンバーガーメニュー切り替え閾値
const isMounted = useMounted()
const isPartSP = computed(() => {
  if (!isMounted.value) return true
  return width.value <= 899
})

const initCheckHeader = () => {
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        isHeaderBlur.value = false
        isLogoActive.value = false
      } else {
        isHeaderBlur.value = true
        isLogoActive.value = true
      }
      isLangSelectActive.value = isLogoActive.value
    }
  })
  if (headerAfter.value) {
    observer.observe(headerAfter.value)
  }
}

const localePath = useLocalePath()
const clickTransitionHeaderButton = (transition: actionTransitionType) => {
  actionTransition(localePath(transition))
  if (isPartSP.value) {
    close();
  }
}

const clickReservedForm = () => {
  const url = externalTransitionType.reserve[locale.value];
  actionExternalNewTabTransition(url);
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#header {
  z-index: v.$zindex-header;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  width: 100%;
  /* height: 80px; */
  height: min(21.33vw, 80px);

  background: v.$bg-header-color;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease-out;

  &.-blur {
    background: v.$bg-header-half-transparent-color;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  @include m.partSP {
    position: fixed;
    top: initial;
    bottom: 0;
  }
}

.header-after {
  position: absolute;
  top: -1px;
  height: 0;
  pointer-events: none;
}

.header-content {
  transition: all 0.3s ease-out;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  position: relative;
  display: flex;

  /* メニューのロゴ部分 */
  .header-logo {
    transition: 0.3s all ease-out;
    opacity: 0;
    margin-left: 4%;
    padding: 16px;

    /* メニュー表示が崩れないように暫定対応 */
    @media screen and (max-width: 1320px) {
      margin-left: 0;
    }
    &.-active {
      opacity: 1;
      cursor: pointer;
    }
  }

  .header-button-content {
    display: flex;
    justify-content: right;
    max-width: 1128px;
    width: 80%;

    .header-button {
      cursor: pointer;
      z-index: v.$zindex-header;
      transition: all 0.3s ease-out;
      background: none;
      border: 0;
      font-family: v.$accent-font-family;
      font-weight: v.$font-weight-regular;
      width: 100%;
      height: 100%;
      align-content: center;
      letter-spacing: 0.3em;
      line-height: 1.25;
    }

    .header-button-middle {
      position: relative;
      display: block;
      max-width: 106px;
      height: 80px;

      .text {
        width: 100%;
        display: inline-block;
        font-weight: v.$font-weight-regular;
        @include u.localize-text;
        font-size: clamp(0.6rem, 1vw, 0.75rem);
        text-align: center;
      }
      &::after {
        content: '';
        position: absolute;
        display: block;
        left: 50%;
        transform: translateX(-50%);
        bottom: 3px;
        width: 0;
        height: 0;
        opacity: 0;
        background: v.$accent-color;
        transition: all 0.3s ease-out;
      }
      &:hover::after {
        width: 100%;
        height: 2px;
        opacity: 1;
      }
      .text_jp {
        letter-spacing: 0.15em;
      }

      /* PC版ヘッダーメニューのホバー時の挙動 */
      span {
        z-index: v.$zindex-header;
        position: absolute;
        align-content: center;
        text-align: center;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
      }
      span:nth-child(2) {
        opacity: 0;
      }
      &:hover span:nth-child(1) {
        opacity: 0;
      }
      &:hover span:nth-child(2) {
        opacity: 1;
      }

      /* PC版ヘッダーメニューのホバー時の挙動（英語） */
      &.-en {
        /* ホバーしても何も起こらないようにCSS上書き */
        &:hover span:nth-child(1) {
          opacity: 1;
        }
        span:nth-child(2) {
          display: none;
        }
      }
    }

    .header-button-icon-text {
      display: grid;
      border: 0px;
      grid-template-columns: 100%;
      grid-template-rows: 10% 45% 45%;
      background: v.$bg-white-color;
      place-items: center;
      padding-block: 0px;
      padding-inline: 0px;
      .text {
        grid-column: 1 / 2;
        grid-row: 3 / 4;
        font-size: 0.875rem;
      }
      .svg-icon {
        grid-column: 1 / 2;
        grid-row: 2 / 3;
        height: 100%;
        aspect-ratio: 1 / 1;

        mask-size: contain;
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .header-button-icon-text:hover {
      .svg-icon {
        background-color: v.$bg-white-color;
      }
    }

    /* プラン/ご予約ボタン */
    .reservation-button {
      color: v.$text-white-color;
      margin: 16px 30px;
      height: 48px;
      width: 100%;
      max-width: 240px;
      background: v.$accent-color;

      /* メニュー表示が崩れないように暫定対応 */
      @media screen and (max-width: 1320px) {
        margin: 16px 10px;
      }

      .text {
        color: v.$common-white-color;
        font-family: v.$base-font-family;
        font-size: 1rem;
        letter-spacing: 2.4px;
        padding: 0 16px;
        white-space: nowrap;
      }

      &:hover {
        background: v.$accent-hover-color;
      }
    }
  }

  /* SPのヘッダーボタン部分 */
  .header-button-sp-content {
    display: flex;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    margin: 0 auto;
    padding: 0 4px;

    .header-button-sp {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      align-content: center;
      flex-grow: 1;
      padding: 4px;
      margin-right: 10px;
      flex: 0.3;
      gap: 8px;
      container-type: inline-size;
      @include m.sp() {
        flex-direction: column;
        /* width: 19.73vw; */
        flex: 0.5;
        gap: 2px;
      }

      .text {
        font-family: v.$accent-font-family;
        font-size: clamp(0.1rem, 2.8vw, 1rem);
        letter-spacing: 1.5px;
        color: v.$text-base-color;
        white-space: nowrap;
        text-align: center;
        @include m.sp() {
          /* font-size: clamp(0.1rem, 2.8vw, 0.75rem);  */
          font-size: clamp(0rem, 19cqw, 0.75rem);
        }
        &.-en {
          font-family: v.$accent-font-family;
          letter-spacing: 0.3em;
        }
      }
      /* アクセスアイコン */
      .access-icon {
        width: 18px;
        height: 14px;
        background: v.$common-element-color;
        mask-size: contain;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-image: url('~/assets/pages/common/IconAccess.svg');
        mask-size: contain;
        @include m.sp() {
          width: min(3.2vw, 12px);
          height: min(4.8vw, 18px);
          margin-bottom: 2px;
        }
      }
      /* お問い合わせアイコン */
      .contact-icon {
        width: 14px;
        height: 17px;
        background: v.$common-element-color;
        mask-size: contain;
        mask-repeat: no-repeat;
        mask-position: center;
        mask-image: url('~/assets/pages/common/IconContact.svg');
        mask-size: contain;
        @include m.sp() {
          width: min(4.27vw, 16px);
          height: min(4.53vw, 17px);
          margin-bottom: 2px;
        }
      }
      svg {
        display: inline-block;
      }
    }

    /* プラン/ご予約ボタン */
    .reservation-button {
      color: v.$text-white-color;
      width: calc(32vw - 60px);
      height: min(12.8vw, 48px);
      /* height: 48px; */
      flex-grow: 1;
      max-width: 320px;
      container-type: inline-size;
      overflow: hidden;
      background: v.$accent-color;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        color: v.$common-white-color;
        font-size: 1.2rem;
        letter-spacing: 2.4px;
        padding: 0 2vw;
        white-space: nowrap;
      @include m.sp() {
        font-size: clamp(0rem, 10cqw, 1rem);
      }
      }
    }
  }
}

.header-content-nav {
  height: 72px;
}

/* ハンバーガーメニュー */
.ui-hamburger {
  width: min(12.8vw, 48px);
  height: min(12.8vw, 48px);
  text-align: center;
}
.hamburger-button {
  background: none;
  border: 0;
  padding: min(2.13vw, 8px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.bar {
  display: block;
  width: min(5.87vw, 22px);
  height: min(0.27vw, 1px);
  background: currentColor;
  position: relative;
  transition: background 0.2s ease-out;
}
.bar::before,
.bar::after {
  content: '';
  position: absolute;
  left: 0;
  width: min(5.87vw, 22px);
  height: min(0.27vw, 1px);
  background: currentColor;
  transition: transform 0.25s ease-out;
}
.bar::before { top: calc(min(2.13vw, 8px) * -1);  }
.bar::after { top: min(2.13vw, 8px);  }
.bar.open {
  background: transparent;
}
.bar.open::before { transform: translateY(min(2.13vw, 8px)) rotate(45deg);  }
.bar.open::after { transform: translateY(calc(min(2.13vw, 8px) * -1)) rotate(-45deg); }

.hamburger-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 10;
}
.hamburger-menu {
  width: 100%;
  background: v.$bg-header-color;
  height: 100%;
  padding: 24px 24px 64px;
  box-sizing: border-box;
  overflow-y: auto;

  .header-logo {
    .logo {
      min-width: 100px;
      width: 20%;
    }
  }
}
/* ハンバーガーメニューのメニューリスト */
.menu-list {
  list-style: none;
  padding: 0;
  .menu-item {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0 8px 12px;
    border: 0;
    background: none;
    cursor: pointer;
    font-size: 1rem;
  }
  &.line {
    .menu-item + .menu-item {
      border-top: 1px solid v.$border-list-color;
    }
  }
}

/* ハンバーガーメニューの各メニュータイトル */
.menu-title {
  font-family: v.$accent-font-family;
  font-weight: v.$font-weight-light;
  font-size: 1.25rem;
  color: v.$accent-color;
  letter-spacing: 8px;
}
/* ハンバーガーメニューの各メニュー説明文 */
.menu-description {
  font-size: 0.875rem;
  color: v.$text-base-color;
  letter-spacing: 5.6px;
}

.fade-enter-active, .fade-leave-active { transition: opacity .2s }
.fade-enter-from, .fade-leave-to { opacity: 0 }
</style>
